// Board cover colours. A board stores a palette KEY (e.g. "teal"); when null we
// pick a deterministic one from its id so every board looks intentional.

type Stops = [string, string];

export const BOARD_PALETTE: Record<string, Stops> = {
  teal: ["#0f766e", "#2dd4bf"],
  blue: ["#1d4ed8", "#60a5fa"],
  indigo: ["#4338ca", "#818cf8"],
  purple: ["#7e22ce", "#c084fc"],
  pink: ["#be185d", "#f472b6"],
  red: ["#b91c1c", "#f87171"],
  orange: ["#c2410c", "#fb923c"],
  amber: ["#b45309", "#fbbf24"],
  green: ["#15803d", "#4ade80"],
  slate: ["#334155", "#94a3b8"],
};

export const BOARD_COLOR_KEYS = Object.keys(BOARD_PALETTE);

function hashString(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
  }
  return hash;
}

/** The palette key actually used for a board (stored or deterministic). */
export function boardColorKey(board: { id: string; color: string | null }): string {
  if (board.color && BOARD_PALETTE[board.color]) return board.color;
  return BOARD_COLOR_KEYS[hashString(board.id) % BOARD_COLOR_KEYS.length];
}

export function gradientForKey(key: string): string {
  const [from, to] = BOARD_PALETTE[key] || BOARD_PALETTE.teal;
  return `linear-gradient(135deg, ${from} 0%, ${to} 100%)`;
}

/** CSS gradient string for a board's cover. */
export function boardGradient(board: { id: string; color: string | null }): string {
  return gradientForKey(boardColorKey(board));
}
